import { create } from 'zustand'

interface PreviewStore {
  selectedUid: string | null
  hoveredUid: string | null
  draggingUid: string | null
  // Editor toggle: the nav blocks navigate instead of selecting, so they lose their frame.
  navigationEnabled: boolean

  setSelected: (uid: string | null) => void
  setHovered: (uid: string | null) => void
  setDragging: (uid: string | null) => void
  setNavigationEnabled: (enabled: boolean) => void
  reset: () => void
}

export const usePreviewStore = create<PreviewStore>()(set => ({
  selectedUid: null,
  hoveredUid: null,
  draggingUid: null,
  navigationEnabled: false,

  setSelected: uid => set({ selectedUid: uid }),
  setHovered: uid => set({ hoveredUid: uid }),
  setDragging: uid => set({ draggingUid: uid }),
  setNavigationEnabled: enabled => set({ navigationEnabled: enabled }),
  reset: () => set({ selectedUid: null, hoveredUid: null, draggingUid: null, navigationEnabled: false }),
}))
